import { requestKarangoApi } from "../../core/api/karangoTransport";

// Utilisateur certifie par parrainage (ADR-020). Le serveur relit tous les droits.

export async function getMemberCertificationStatus(targetUserId) {
  return requestKarangoApi(`/v1/profiles/${encodeURIComponent(targetUserId)}/member-certification`, { requiresAuth: true });
}

export async function requestMemberCertification(targetUserId) {
  const payload = await requestKarangoApi(`/v1/profiles/${encodeURIComponent(targetUserId)}/member-certification`, {
    method: "POST",
    requiresAuth: true,
  });
  return payload?.request ?? null;
}

export async function cancelMemberCertification(requestId) {
  return requestKarangoApi(`/v1/member-certifications/${encodeURIComponent(requestId)}/cancel`, { method: "POST", requiresAuth: true });
}

export async function getMemberCertificationRequest(requestId) {
  const payload = await requestKarangoApi(`/v1/member-certifications/${encodeURIComponent(requestId)}`, { requiresAuth: true });
  return payload?.request ?? null;
}

export async function respondToMemberCertification(requestId, accept) {
  return requestKarangoApi(
    `/v1/member-certifications/${encodeURIComponent(requestId)}/${accept ? "accept" : "decline"}`,
    { method: "POST", requiresAuth: true }
  );
}
